import { CsvGuidelines } from '@payaca/types/csvUploadTypes';

import type { JSX } from "react";

type Props = {
  csvGuidelines: CsvGuidelines;
};
const BulkCsvGuidelines = ({ csvGuidelines }: Props): JSX.Element => {
  return (
    <>
      {csvGuidelines &&
        csvGuidelines.map((bulkUploadCsvGuideline, i) => {
          return (
            <li key={`bulk-upload-instruction-guideline-${i}`}>
              <span>{bulkUploadCsvGuideline.header}</span>
              <span>: {bulkUploadCsvGuideline.guideline}</span>
            </li>
          );
        })}
    </>
  );
};

export default BulkCsvGuidelines;
